<mat-dialog-content>
 <div [innerHTML]="data"></div>
</mat-dialog-content>

<mat-dialog-actions>
    <button color="primary" mat-button mat-dialog-close>LUK</button>
</mat-dialog-actions>

